<template>
    <section class="booking-order-com f28">
      <div class='contented'>
        <div class="server-img">
          
          <img  v-if='model.goodsPhoto' :src="formatImgUrl(model.goodsPhoto,300,300,true)" alt=""/>
          <img  v-if='model.pic' :src="formatImgUrl(model.pic,300,300,true)" alt=""/>
          <img  v-else :src="formatImgUrl(model.defaultPic,300,300,true)" alt=""/>

          <div class="dis-repair" v-if='makeCheck()'>
            <img src="/images/order/dis-repair.png" alt=""/>
          </div>
        </div>
        <div class="server-info">
          <div v-if='model.brand'>{{model.brand}}</div>
          <div v-if='model.category' class='colorG'>{{model.category}}</div>
          <div>{{model.name}}</div>
        </div>
      </div>
      <!-- <div class="server-price">{{model.price}}<span v-show='model.serviceCount'>x{{model.serviceCount}}</span></div> -->
    </section>
</template>

<script>
  export default {
    name: 'com-online-shop',
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      }
    },
    props: {
      model : {
        type : Object,
        default : ()=>{
          return {}
        }
      }
    },
    created(){
      // console.log(this.model)
    },
    methods : {
      formatImgUrl(url, width, height,m_fill) {
        
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }else{
          url = '/images/base/defult_pic.png'
        }
        return url
      },
      makeCheck(){
        if(this.model.goodsCuringServiceBoList){
          if(this.model.goodsCuringServiceBoList[0]){
            if(this.model.goodsCuringServiceBoList[0].curingServiceName == '无法修复'){
              return true;
            } 
          }
        }
        return false;
      },
    }
  }
</script>

<style scoped lang="scss">
  .colorG{
    color:#666666;
    font-weight:400;
  }
.contented{
  display: flex;
  justify-content: flex-start;
  width: 530px;
}
  .booking-order-com{
    width: 100%;
    display: flex;
    height: 164px;
    justify-content: space-between;
    .server-img{
      flex: none;
      width: 164px;
      height: 164px;
      overflow: hidden;
      position: relative;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
      .dis-repair{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,.3);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 104px;
          height: 104px;
        }
      }
    }
    .server-info{
      margin-left: 30px;
      max-width: 360px;
      flex: auto;
      div{
        line-height: 40px;
        margin-bottom: 20px;
        width: 260px;
        // overflow: hidden;
        font-weight: 500;
        white-space: wrap;
        text-align: left;
        // text-overflow: ellipsis;
      }
    }
    .server-price{
      line-height: 40px;
      font-weight: 500;
      span{
        font-size:20px;
        color:#666666; 
        margin-left:8px;
      }
      // margin-right: 30px;
    }
  }
</style>
